import { Col, Row, Typography, } from "antd";
import TopFilters from "./Components/TopFilters";
import ListItems from "./Components/ListItems";
import PageTitle from "apps/Common/PageTitle";
import MobileTopFilters from "./Components/MobileTopFilters";

const SummaryIndex = () => {


  return (
    <>
      <Row gutter={[20, 20]}>
        
        <Col xs={24} className="!hidden md:!block" >
          <TopFilters isMobile={false}/>
        </Col>
        <Col xs={24} className="!block md:!hidden" >
        <MobileTopFilters/>
        </Col>
       <Col xs={24} >
        <ListItems/>
       </Col>
        
      </Row>
    </>
  );
};

export default SummaryIndex;
